/* =========================================================
   Bestcold — custom event bridge (Milestone 6)
   ---------------------------------------------------------
   This file does NOT initialize GA4, Meta Pixel, Google Ads, or Klaviyo
   itself — hardcoding those scripts into the theme is exactly what
   causes duplicate tracking (Shopify's own Customer Events / Web Pixels
   already fire standard commerce events like Add to cart, Checkout
   started, Purchase). See AUTOMATION_EVENTS.md for the full reasoning
   and the Shopify Admin setup steps.

   What this file DOES do: give Bestcold's storefront a single, documented
   place to fire the custom events from AUTOMATION_EVENTS.md that have no
   native Shopify equivalent (quote_requested, service_requested, and any
   future on-site custom event) — bridged out to:
     1. window.dataLayer — the de-facto standard array a Shopify Custom
        Pixel or GTM container can subscribe to, if the store uses one.
     2. window.klaviyo — Klaviyo's own onsite object, auto-injected once
        the official Klaviyo Shopify app is installed (no API key needed
        in theme code). Guarded with a typeof check so this is a silent
        no-op until that app exists.
   Every call is safe to make even if neither destination is present.
   ========================================================= */
(function () {
  'use strict';

  window.BestcoldEvents = window.BestcoldEvents || {
    track: function (name, properties) {
      properties = properties || {};

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, properties));

      if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['track', name, properties]);
      }

      /* Shopify's eigen pixel-laag. Een Custom Pixel (Instellingen ->
         Klantgebeurtenissen) vangt deze events op met analytics.subscribe
         onder dezelfde naam en stuurt ze door naar GA4.

         Waarom via deze weg en niet met gtag.js in het thema: alles loopt
         dan door een verzamelpunt dat Shopify's eigen commerce-events al
         kent, zodat purchase en add_to_cart niet een tweede keer geteld
         worden. Bijkomend voordeel is dat Shopify de events zelf achterhoudt
         tot de bezoeker toestemming heeft gegeven in de cookiebanner; we
         bouwen daar dus geen eigen laag naast.

         replayQueue vangt op wat er gepubliceerd wordt voordat de pixel
         geladen is, dus een vroege call gaat niet verloren. Alles staat in
         een try/catch: analytics ontbreekt in de Theme Editor-preview en in
         oudere contexten, en een meetfout mag de winkel nooit breken. */
      try {
        if (window.Shopify && window.Shopify.analytics
            && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish(name, properties);
        }
      } catch (err) { /* meten mag nooit de storefront breken */ }
    }
  };

  /* ---------------------------------------------------------
     Contact form → quote_requested / service_requested.
     Shopify's native contact form doesn't echo custom field values back
     after its redirect-on-success, so the selected "Onderwerp" is
     captured to sessionStorage right before submit, then read back
     (once) after the page reloads with form.posted_successfully true.
     --------------------------------------------------------- */
  var STORAGE_KEY = 'bestcold_contact_topic';

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.contact-form-section__form');
    if (!form) return;
    var topicSelect = form.querySelector('[data-contact-topic]');
    if (topicSelect) {
      try { sessionStorage.setItem(STORAGE_KEY, topicSelect.value); } catch (err) { /* ignore storage errors (private mode etc.) */ }
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    var postedFlag = document.querySelector('[data-contact-posted]');
    if (!postedFlag) return;

    var topic;
    try { topic = sessionStorage.getItem(STORAGE_KEY); } catch (err) { topic = null; }

    var eventName = 'contact_form_submitted';
    if (topic === 'offerte') eventName = 'quote_requested';
    else if (topic === 'service' || topic === 'onderhoud') eventName = 'service_requested';

    window.BestcoldEvents.track(eventName, { topic: topic || 'unknown' });

    try { sessionStorage.removeItem(STORAGE_KEY); } catch (err) { /* ignore */ }
  });
})();
